import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { fetchCurrentUser } from "@/lib/auth";

export const Route = createFileRoute("/_auth")({
	beforeLoad: async () => {
		// If already authenticated, redirect to dashboard
		const user = await fetchCurrentUser();
		if (user) {
			throw redirect({ to: "/dashboard" });
		}
	},
	component: AuthLayout,
});

function AuthLayout() {
	return (
		<div className="flex min-h-screen flex-col items-center justify-center bg-muted/40 p-4">
			<span className="mb-8 text-xl font-semibold tracking-tight">Burresi</span>
			<div className="w-full max-w-md">
				<Outlet />
			</div>
		</div>
	);
}
